import { apiGet, apiPost } from './api';
import type { Customer, CreateCustomerRequest } from '../types/customer';

export async function getCustomers(): Promise<Customer[]> {
  const response = await apiGet<{ customers: Customer[] }>('/customers');
  return response.customers;
}

export async function getCustomer(customerId: string): Promise<Customer> {
  return apiGet<Customer>(`/customers/${customerId}`);
}

export async function createCustomer(data: CreateCustomerRequest): Promise<Customer> {
  return apiPost<Customer>('/customers', data);
}
